import styled from 'styled-components'
import { BankSessionContainer } from './BankSessionListItem'

export const BankSessionListContainer = styled.div`
	& ${BankSessionContainer}:not(:first-child) {
		margin-top: 40px;
	}
`

export const LoadingContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
`
